export default "__VITE_ASSET__deXYFv0___"